import { en } from './en'
import { fr } from './fr'

export const dashboardPage = { en, fr }
